import { create } from 'zustand';

export type SessionSource = 'verified' | 'cached' | 'read-only' | 'none';

export interface SessionPayload {
  sessionToken?: string;
  traceId?: string;
  userId?: number;
  telegramUserId?: number;
  sessionSource?: SessionSource;
}

export interface SessionState extends SessionPayload {
  setSession: (payload: SessionPayload) => void;
  clear: () => void;
}

export const useSessionStore = create<SessionState>(set => ({
  sessionToken: undefined,
  traceId: undefined,
  userId: undefined,
  telegramUserId: undefined,
  sessionSource: 'none',
  setSession: payload =>
    set({
      sessionToken: payload.sessionToken,
      traceId: payload.traceId,
      userId: payload.userId,
      telegramUserId: payload.telegramUserId,
      sessionSource: payload.sessionSource ?? 'none',
    }),
  clear: () =>
    set({
      sessionToken: undefined,
      traceId: undefined,
      userId: undefined,
      telegramUserId: undefined,
      sessionSource: 'none',
    }),
}));
